import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { MarqueeBand } from "./components/Marquee";
import { About } from "./components/About";
import { Gallery } from "./components/Gallery";
import { EtsyShowcase } from "./components/EtsyShowcase";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { adminAuth } from "./lib/adminApi";

const Home = () => (
  <main className="bg-[#050505] text-white min-h-screen">
    <Header />
    <Hero />
    <MarqueeBand />
    <About />
    <Gallery />
    <EtsyShowcase />
    <Contact />
    <Footer />
  </main>
);

const RequireAdmin = ({ children }) => {
  return adminAuth.getToken() ? children : <Navigate to="/admin" replace />;
};

function App() {
  return (
    <div className="App bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/leads"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid #27272A",
            color: "#fff",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
